import src from "IMAGE";
export default { src, width: 400, height: 400, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAASklEQVR42r3NoQ0AIRBE0b0TV8BpJI4mqABNFbSBoy5KIARJIXwkyWomee4nI3LuR0XBJ8peJExkBC1y6GgYWuARYWC1YH8/cm8LYgwHMECfXIgAAAAASUVORK5CYII="};
